import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  PlayOffWrapper,
  PlayOffContainer,
  TouenamentWrapper,
  RoundWrapper,
  HeaderContainer,
  RoundHeader,
  Spacer,
} from './styles';
import Tabellone from './Tabellone';
import TabelloneRugby from './TabelloneRugby';


class PlayOffChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      //isTablet: false,
      openDetailKey: null,
    };
  }

  // componentDidMount() {
  //   const { sportId, competitionId } = this.props;
  //   if (String(sportId) === '1') {
  //     this.props.actions.getPlayoffPhase(sportId, competitionId, 2);
  //   }
  // }

  moveTo = (px) => {
    document.querySelector('.PlayOffContainer').scrollTo({
      left: px,
      behavior: 'smooth',
    });
  };

  moveBy = (px) => {
    document.querySelector('.PlayOffContainer').scrollBy({
      left: px,
      behavior: 'smooth',
    });
  };

  openSingleDetail = (openDetailKey) => {
    this.setState({ openDetailKey });
  }

  createTabs = () => {
    const tabs = [];
    this.props.rounds.contents.forEach((x) => {
      tabs.push({
        label: this.props.dictionary.competitionTable.roundName[x.roundName],
        id: x.roundName,
      });
    });
    return tabs;
  }

  switchTabs = (tab) => {
    const el = document.querySelector(`ul.${tab}`);
    if (el) {
      this.moveTo(el.offsetLeft - 10);
    }
  }

  phaseLabel = (index) => {
    const { dictionary, sportId } = this.props;
    if (String(sportId) === '2') {
      index = `${index}_${sportId}`;
      if (dictionary.calendar.subPhases[index]) {
        return dictionary.calendar.subPhases[index];
      }
    }
    if (dictionary.competitionTable.roundName[index]) {
      return dictionary.competitionTable.roundName[index];
    }
    return '';
  }

  renderLastSpace = index => [
    <Spacer key={index}>&nbsp;</Spacer>,
  ];

  renderHTML = rawHTML => React.createElement('span', { dangerouslySetInnerHTML: { __html: rawHTML } });

  render() {
    const {
      rounds, dictionary, isMobile, competitionId, sportId, actions, subPhase,
    } = this.props;
    const roundObject = rounds.contents;
    return (
      <PlayOffWrapper>
        <PlayOffContainer showArrrows={false} className="PlayOffContainer">
          <HeaderContainer>
            {((String(sportId) === '2' && String(competitionId) !== '212')) && roundObject && Object.keys(roundObject).map((round, index) => (
              <RoundHeader
                key={index}
                className={round}
              >
                {this.renderHTML(dictionary.competitionTable.roundName[round])}
              </RoundHeader>
            ))}
            {(String(sportId) === '2' && String(competitionId) === '212') && roundObject && roundObject.filter(r => r.roundName === subPhase).map((round, index) => (
              <RoundHeader
                key={index}
                className={round.roundName}
              >
                {String(sportId) === '2' && this.renderHTML(this.phaseLabel(round.roundName))}
              </RoundHeader>
            ))}
          </HeaderContainer>
          <TouenamentWrapper hasDetails={!isMobile && (String(sportId) === '5' || String(sportId) === '3' || String(sportId) === '2')} sportId={sportId}>
            {roundObject && Object.keys(roundObject).filter(r => roundObject[r].roundName === subPhase).map((round, index) => (
              <RoundWrapper
                key={index}
                className={String(sportId) !== '2' ? 'RoundWrapper' : `RoundWrapper ${roundObject[round].roundName}`}
              >
                {(String(sportId) === '2' && String(competitionId) === '212') && roundObject[round].partite.map((match, i) => (
                  <TabelloneRugby
                    competitionId={competitionId}
                    isMobile={isMobile}
                    actions={actions}
                    key={`${index + 1}${i}`}
                    reactKey={`${index + 1}${i}`}
                    match={match}
                    i={i}
                    round={index}
                    maxRound={roundObject.length}
                    maxPartite={roundObject[round].partite.length}
                    sportId={sportId}
                    openSingleDetail={this.openSingleDetail}
                    isOpen={this.state.openDetailKey === `${index + 1}${i}`}
                    moveTo={this.moveTo}
                  />
                ))}
                {String(sportId) === '2' && String(competitionId) !== '212' && roundObject[round].map((match, i) => (
                  <Tabellone
                    competitionId={competitionId}
                    isMobile={isMobile}
                    key={`${index + 1}${i}`}
                    match={match}
                    i={i}
                    round={index}
                    sportId={sportId}
                    moveTo={this.moveTo}
                  />
                ))}
                {this.renderLastSpace(roundObject[round].length + 1)}
              </RoundWrapper>
            ))}
          </TouenamentWrapper>
        </PlayOffContainer>
      </PlayOffWrapper>
    );
  }
}

PlayOffChart.propTypes = {
  rounds: PropTypes.any,
  dictionary: PropTypes.any,
  actions: PropTypes.any,
  sportId: PropTypes.any,
  competitionId: PropTypes.any,
  isMobile: PropTypes.bool,
  subPhase: PropTypes.any,
};

export default PlayOffChart;



// WEBPACK FOOTER //
// ./src/components/PlayOffChart/index.js